'use strict';

import 'slick-carousel';

export const carousel = (() => {
    /**
     * init
     */
    const init = () => {

        $('.js-carousel').each((index, element) => {
            const $this = $(element);

            $this.on('init', function (event, slick, currentSlide) {
                $this.next('.js-carousel-page').children('.total').text(slick.slideCount);
                $this.next('.js-carousel-page').children('.current').text(slick.currentSlide + 1);
            });

            $this
                .not('.slick-initialized')
                .slick({
                    speed: 600,
                    cssEase: 'ease-out',
                    adaptiveHeight: true,
                    infinite: false,
                    prevArrow:
                        '<div class="slick-arw slick-arw--prev"></div>',
                    nextArrow:
                        '<div class="slick-arw slick-arw--next"></div>'
                });

            $this.on('afterChange', function (event, slick, currentSlide) {
                $this.next('.js-carousel-page').children('.current').text(slick.currentSlide + 1);
            });
        });
    };

    return {
        init: init
    };
})();
